import React, { useState, useRef } from "react";
import styles from "./RegisterPopupForm.module.css";
import { API } from "../../AmsConfig";
import Captcha from "../includes/Captcha";

const RegisterPopupForm = ({ isOpen, onClose }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phonenumber, setphonenumber] = useState("");
  const [address, setAddress] = useState("");
  const [location, setLocation] = useState("");
  const [flatname, setflatname] = useState("");
  
  // New Loading State
  const [loading, setLoading] = useState(false);

  const [captchaInput, setCaptchaInput] = useState("");
  const [captchaValue, setCaptchaValue] = useState("");
  const captchaRef = useRef(null);

  if (!isOpen) return null;

  const resetForm = () => {
    setName("");
    setEmail("");
    setphonenumber("");
    setflatname("");
    setAddress("");
    setLocation("");
    setCaptchaInput("");
    setLoading(false);
    if (captchaRef.current) {
      captchaRef.current.refreshCaptcha();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (captchaInput.toLowerCase() !== captchaValue.toLowerCase()) {
      alert("Incorrect CAPTCHA. Please try again.");
      return;
    }

    if (phonenumber.length !== 10) {
      alert("Phone number must be 10 digits.");
      return;
    }

    const formData = {
      name,
      email,
      phonenumber,
      address,
      location,
      flatname,
      plan_id: 1,
      amount: 0
    };

    // Start Loading
    setLoading(true);

    try {
      const res = await fetch(API.FLAT_REGISTER, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      const contentType = res.headers.get("content-type");
      if (!contentType || !contentType.includes("application/json")) {
        throw new Error("Server Error: Invalid Response Format.");
      }

      const data = await res.json();

      if (res.ok) {
        // Updated Success Message
        alert("Registration Successful! Credentials have been sent to your email. Please note: It may take 3-5 minutes for the email to arrive.");
        resetForm();
        onClose();
      } else {
        alert(data.error || "Registration failed");
      }
    } catch (error) {
      console.error("Error:", error);
      alert("Something went wrong. Please try again.");
    } finally {
      // Stop Loading regardless of success or failure
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.overlay} onClick={() => { if(!loading) onClose(); }}></div>
      <div className={styles.popup}>
        <button 
          className={styles.closeBtn} 
          onClick={() => { if(!loading) onClose(); }}
          disabled={loading}
        >
          ✕
        </button>

        <h3>Register Now</h3>

        <form onSubmit={handleSubmit}>
          <input type="text" placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} required disabled={loading} />
          <input type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} required disabled={loading} />
          <input type="number" placeholder="Phone Number" value={phonenumber} onChange={(e) => setphonenumber(e.target.value)} required disabled={loading} />
          <textarea placeholder="Address" value={address} onChange={(e) => setAddress(e.target.value)} required disabled={loading}></textarea>
          <input type="text" placeholder="Location" value={location} onChange={(e) => setLocation(e.target.value)} required disabled={loading} />
          <input type="text" placeholder="Flat Name" value={flatname} onChange={(e) => setflatname(e.target.value)} required disabled={loading} />

          <div className={styles.captchaSection}>
            <Captcha setCaptchaValue={setCaptchaValue} ref={captchaRef} />
            <input
              type="text"
              placeholder="Enter CAPTCHA"
              value={captchaInput}
              onChange={(e) => setCaptchaInput(e.target.value)}
              required
              disabled={loading}
            />
          </div>

          <button type="submit" className={styles.submitBtn} disabled={loading}>
            {loading ? (
              <div className={styles.loaderContainer}>
                <span className={styles.spinner}></span>
                <span>Please wait...</span>
              </div>
            ) : (
              "Submit"
            )}
          </button>
        </form>

        <div className={styles.formFooter}>
          Already have an account? 
          <a className={styles.linkText} href="https://ams.bsparksoftwaretechnologies.com/login" target="_blank" rel="noreferrer">
             Sign In
          </a>
        </div>
      </div>
    </>
  );
};

export default RegisterPopupForm;